(function () {
  'use strict';

  if (window.CPLazyVideo) return;

  var SELECTOR = 'video[data-lazy-video]';
  // Start loading one screen ahead so the video is already playing when the customer arrives.
  var ROOT_MARGIN = '100% 0px 100% 0px';
  var blocked = [];
  var observer = null;

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function saveData() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return !!(c && c.saveData);
  }

  function applyPoster(video) {
    var poster = video.getAttribute('data-poster');
    if (!poster) return;
    video.setAttribute('poster', poster);
    video.removeAttribute('data-poster');
  }

  function shouldSkip(video) {
    if (!video.getAttribute('poster')) return false;
    return saveData() || prefersReducedMotion();
  }

  function attemptPlay(video) {
    if (!video.autoplay || video.isConnected === false) return;
    video.muted = true;
    var promise;
    try {
      promise = video.play();
    } catch (e) {
      return;
    }
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {
        if (blocked.indexOf(video) === -1) blocked.push(video);
        video.classList.add('v1-video--blocked');
      });
    }
  }

  function load(video) {
    if (video.dataset.lazyVideoLoaded === 'true') return;

    var sources = video.querySelectorAll('source[data-src]');
    var added = 0;

    for (var i = 0; i < sources.length; i++) {
      var src = sources[i].getAttribute('data-src');
      if (!src) continue;
      var type = sources[i].getAttribute('type');
      if (type && video.canPlayType && video.canPlayType(type) === '' && sources.length > 1) {
        sources[i].parentNode.removeChild(sources[i]);
        continue;
      }
      sources[i].setAttribute('src', src);
      sources[i].removeAttribute('data-src');
      added++;
    }

    if (!added) return;
    video.dataset.lazyVideoLoaded = 'true';
    video.load();
    attemptPlay(video);
  }

  function onIntersect(entries) {
    for (var i = 0; i < entries.length; i++) {
      var video = entries[i].target;
      if (entries[i].isIntersecting) {
        applyPoster(video);
        if (shouldSkip(video)) {
          observer.unobserve(video);
          continue;
        }
        load(video);
        if (video.paused) attemptPlay(video);
      } else if (video.dataset.lazyVideoLoaded === 'true' && !video.paused) {
        video.pause();
      }
    }
  }

  function observe(video) {
    if (video.dataset.lazyVideoBound === 'true') return;
    video.dataset.lazyVideoBound = 'true';

    video.addEventListener('loadeddata', function () {
      video.classList.add('v1-video--loaded');
    });
    video.addEventListener('error', function () {
      video.classList.add('v1-video--error');
    }, true);

    if (observer) {
      observer.observe(video);
    } else {
      applyPoster(video);
      load(video);
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var videos = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < videos.length; i++) observe(videos[i]);
  }

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(onIntersect, { rootMargin: ROOT_MARGIN, threshold: 0 });
  }

  function retryBlocked() {
    var pending = blocked.slice(0);
    blocked.length = 0;
    for (var i = 0; i < pending.length; i++) {
      pending[i].classList.remove('v1-video--blocked');
      attemptPlay(pending[i]);
    }
  }

  ['touchstart', 'click', 'keydown'].forEach(function (evt) {
    document.addEventListener(evt, retryBlocked, { passive: true });
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') retryBlocked();
  });

  window.CPLazyVideo = { init: init, load: load };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
